<template>
    <div class="finally_content">
        <div class="firsecond_top">
            <p>联合发起机构</p>
            <img src="../../img/organizer.png" class="top_img" />
        </div>
        <div class="img-grounp">
            <img src="../../img/1.png" />
            <img src="../../img/3.png" />

        </div>
    </div>
</template>

<script>
    export default {
        name:'firseven',
        data(){
            return {
                
            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
   .finally_content{
        height:360px;
        background:rgba(248,248,248,1);
        min-width: 1334px;
        overflow: hidden;
        .firsecond_top{
            text-align: center;
            font-size:36px;
            font-weight:bold;
            color:rgba(24,24,24,1);
            letter-spacing:2px;
            margin:72px 0 25px;
            .top_img{
                width:314px;
                height: 68px;
                position: relative;
                top:-40px;
            }
        }
        .img-grounp{
            min-width: 1334px;
            text-align: center;
            height: 78px;
            img{
                vertical-align: middle;
                margin-right: 50px;
                margin-left: 50px;
                margin-bottom: 51px;
            }
        }
        
    }
</style>